import {
  anUpdateCustomInsight,
  anUpdateCustomInsightEnabled,
  mockUpdateCustomInsightEnabledOperationMutation,
  mockUpdateCustomInsightOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockUpdateCustomInsightEnabledOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          updateCustomInsightEnabled: anUpdateCustomInsightEnabled(),
        },
      });
    }
  ),
  mockUpdateCustomInsightOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          updateCustomInsight: anUpdateCustomInsight(),
        },
      });
    }
  ),
];
